"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var addShared = function (values) {
    return (0, service_1.getService)()
        .post('/shares', values)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = addShared;
